import type {Context} from '../types';

export default function imageResponsiveAttributes(context: Context) {
  const {jsonNode} = context.node;
  const {data = {}} = jsonNode;
  const srcsetDisabled = data.img?.srcsetDisabled;
  const sizes = data.img?.sizes;
  const isImage = jsonNode.type === 'Image' || jsonNode.tag === 'img';

  const needed =
    isImage && (typeof srcsetDisabled === 'boolean' || Array.isArray(sizes));
  return {
    needed,
    logData: {
      msg: 'Migrate Image srcset and sizes from data.img to data',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      if (Array.isArray(sizes)) {
        data.sizes = sizes;
        // eslint-disable-next-line webflow/no-delete
        delete data.img.sizes;
        deleteEmptyImgData(data);
      }
      if (typeof srcsetDisabled === 'boolean') {
        data.srcsetDisabled = srcsetDisabled;
        // eslint-disable-next-line webflow/no-delete
        delete data.img.srcsetDisabled;
        deleteEmptyImgData(data);
      }
    },
  };
}

const deleteEmptyImgData = (data: Record<string, string>) => {
  if (data.img && Object.keys(data.img).length === 0) {
    // eslint-disable-next-line webflow/no-delete
    delete data.img;
  }
};
